import React from 'react';
import { AvailableIcons, Typography } from 'src/components-dummy';
import { EmptyStatePreview } from './EmptyStatePreview';
import { CampaignPreviewSkeleton } from './CampaignPreviewSkeleton';
import { useAutoCompleteFetchState } from './useAutoCompleteFetchState';
import { SuggestedOffer } from 'src/services/src/service/email-marketing-campaigns/types';
import {
  ButtonIconStyled,
  CampaignPreviewContainer,
  IconsContainer,
  PreviewHeader,
  PreviewContent,
  AutoCompleteFormStyled,
  PreviewSkuStyled,
} from './CampaignPreview.styles';

interface CampaignPreviewProps {
  template: string;
  templateLoading: boolean;
  templateError: boolean;
  isMobile: boolean;
  setIsMobile: (isMobile: boolean) => void;
  shopId: number;
  selectedOffer: SuggestedOffer;
  isPreview: boolean;
}

export const CampaignPreview = ({
  template,
  templateLoading,
  templateError,
  isMobile,
  setIsMobile,
  shopId,
  selectedOffer,
  isPreview,
}: CampaignPreviewProps): JSX.Element => {
  const { ...autoCompleteProps } = useAutoCompleteFetchState({
    shopId,
    selectedOffer,
  });

  return (
    <CampaignPreviewContainer>
      <PreviewHeader>
        <PreviewSkuStyled>
          <Typography>Previewing SKU</Typography>
          <AutoCompleteFormStyled
            placeholder='Type SKU to preview...'
            openPopUp
            {...autoCompleteProps}
          />
        </PreviewSkuStyled>
        <IconsContainer>
          <ButtonIconStyled
            startIcon={AvailableIcons.DesktopOn}
            variant='secondary'
            onClick={() => setIsMobile(false)}
            disabled={!template}
            active={!isMobile}
          />
          <ButtonIconStyled
            startIcon={AvailableIcons.MobileOn}
            variant='secondary'
            onClick={() => setIsMobile(true)}
            disabled={!template}
            active={isMobile}
          />
        </IconsContainer>
      </PreviewHeader>
      <PreviewContent>
        {templateLoading ? (
          <CampaignPreviewSkeleton />
        ) : template && isPreview && !templateError ? (
          <div dangerouslySetInnerHTML={{ __html: template }} />
        ) : (
          <EmptyStatePreview />
        )}
      </PreviewContent>
    </CampaignPreviewContainer>
  );
};
